import { Badge, Card } from "@mui/material";
import SuiAvatar from "components/SuiAvatar";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiTypography from "components/SuiTypography";
import ContactAvatar from "components/UpStyled/ContactAvatar";
import { nanoid } from "nanoid";
import PropTypes from "prop-types";
import { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import api from "services/api";
import { AccountContext } from "context/account";

const smartdate = require("smartdate");
smartdate.init();

function Conversations({ title, sx = {} }) {
  const account = useContext(AccountContext);
  let userid = account.id;
  const [chats, setChats] = useState([]);
  useEffect(() => {
    try {
      api.chatroom.listChatRoom("all", "", "").then(({ data }) => {
        var result = data.chats.filter((chat) => chat.totalmsgcnt > 0).slice(0, 10);
        setChats([...result, ...result]);
        return data;
      });
    } catch (err) {
      toast.error(`listChatRoom failed!`);
      console.log(err);
    }
  }, []);

  const renderProfiles = chats.map((chat) => (
    <SuiBox key={nanoid()} component="li" display="flex" alignItems="center" py={1} mb={1}>
      <SuiBox mr={2}>
        <Badge variant="dot" color="error" invisible={chat.ts <= chat.viewts}>
          <ContactAvatar room={chat} />
        </Badge>
      </SuiBox>
      <SuiBox className="w-full">
        <SuiBox className="flex justify-between items-center">
          <SuiBox className="flex items-center">
            <SuiTypography variant="button" fontWeight="medium">
              {chat.name}
            </SuiTypography>
            {chat.regardingname && (
              <Link
                to={
                  chat.regardingownerid == userid
                    ? `/produce/all-projects?id=${chat.regardingid}`
                    : `/job/requests?id=${chat.regardingid}`
                }
                target="_blank"
                style={{ color: "inherit" }}
              >
                <SuiTypography variant="button" sx={{ ml: 1 }}>
                  (
                  <SuiTypography
                    sx={{ textDecoration: "underline" }}
                    display="inline"
                    variant="button"
                  >
                    {chat.regardingname}
                  </SuiTypography>
                  )
                </SuiTypography>
              </Link>
            )}
          </SuiBox>
          <SuiTypography variant="caption">{smartdate.format(new Date(chat.ts))}</SuiTypography>
        </SuiBox>
        <div className="flex justify-between">
          <SuiTypography
            variant="caption"
            textTransform="none"
            sx={{
              width: "100%",
              minHeight: "28px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: "2",
              WebkitBoxOrient: "vertical",
            }}
          >
            {chat.lastcontent}
          </SuiTypography>
          <SuiButton
            component={Link}
            to={"/messages/" + (chat.regardingname ? "project" : "general") + "?chatid=" + chat.id}
            variant="text"
            color="dark"
          >
            reply
          </SuiButton>
        </div>
      </SuiBox>
    </SuiBox>
  ));

  return (
    <Card sx={{ height: "100%", maxHeight: "650px", ...sx }}>
      <SuiBox pt={1} px={2}>
        <SuiTypography
          variant="h6"
          fontWeight="medium"
          textTransform="capitalize"
          sx={{ px: 1, mt: 1 }}
        >
          {"Messages"}
        </SuiTypography>
      </SuiBox>
      <SuiBox pt={2} px={2}>
        <SuiTypography variant="h5" fontWeight="medium" textTransform="capitalize">
          {title}
        </SuiTypography>
      </SuiBox>
      <SuiBox p={2} sx={{ overflowY: "auto" }}>
        <SuiBox component="ul" display="flex" flexDirection="column" px={2} m={0}>
          {renderProfiles}
        </SuiBox>
      </SuiBox>
    </Card>
  );
}

// Typechecking props for the Conversations
Conversations.propTypes = {
  title: PropTypes.string.isRequired,
  profiles: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Conversations;
